/**
 * @generated SignedSource<<ab74f2f18575d4ef7c0428e99c074e51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarVariantArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersArticleSections" | "helpersCheckIsLongReadArticle" | "helpersCheckIsMorningStudioArticle" | "helpersCheckIsPhotoEssayArticle" | "helpersStyleArticle" | "helpersStyleSectionContent">;
  readonly " $fragmentType": "helpersAppBarVariantArticle";
};
export type helpersAppBarVariantArticle$key = {
  readonly " $data"?: helpersAppBarVariantArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarVariantArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarVariantArticle"
};

(node as any).hash = "a472ee5b0d58a551d8446287814237e2";

export default node;
